import { useState } from "react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { site } from "@/config/site";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import LatestSection from "./components/LatestSection";
import WorksGallery from "./components/WorksGallery";
import RankingSection from "./components/RankingSection";
import AboutTeaser from "./components/AboutTeaser";
import NewsletterSection from "./components/NewsletterSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  usePageMeta(
    `火影同人动漫 - 穿越、系统、重生、战斗剧情全收录 | ${site.slogan}`,
    site.description,
  );
  const [keyword, setKeyword] = useState("");

  return (
    <>
      <Hero onSearch={(kw) => setKeyword(kw)} />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <WorksGallery keyword={keyword} onClearKeyword={() => setKeyword("")} />
      <RankingSection />
      <AboutTeaser />
      <NewsletterSection />
      <FaqSection />
    </>
  );
}